import { requestHandler, getServiceURL } from "../utils/apiUtils";
import { IOccupancyAPI } from "../views/interfaces";

export interface IOccupancyRates {
  owners_occupancy_N30D: number;
  paid_reservations_N30D: number;
  Market_OR_N30D: number;
  owners_occupancy_L30D: number;
  paid_reservations_L30D: number;
  Market_OR_L30D: number;
  Market_OR_L30_60D: number;
  owners_occupancy_L30D_L60D: number;
  paid_reservations_L30D_L60D: number;
}

export class OccupancyRateAPI {
  static get getOccupancyServiceName() {
    return "GET_OCCUPANCY_RATE";
  }

  static get getMarketOccupancyServiceName() {
    return "GET_MARKET_OCCUPANCY_RATE";
  }

  static get getYearlyOccupancyRateServiceName() {
    return "GET_YEARLY_OCCUPANCY_RATE";
  }

  static get getYearlyMarketOccupancyServiceName() {
    return "GET_YEARLY_MARKET_OCCUPANCY";
  }

  static get getPaidReservationsOccupancyServiceName() {
    return "GET_PAID_RESERVATIONS_OCCUPANCY";
  }

  static get getOwnerBlocksOccupancyServiceName() {
    return "GET_OWNER_BLOCKS_OCCUPANCY";
  }

  static get getDailyOccupancyServiceName() {
    return "GET_DAILY_OCCUPANCY";
  }

  static async getOccupancy({ param }: IOccupancyAPI): Promise<object> {
    const url = getServiceURL(OccupancyRateAPI.getOccupancyServiceName);
    const response = await requestHandler(url, { param });
    return response?.data?.OccupancyRate;
  }

  static async getMarketOccupancy({ param }: IOccupancyAPI): Promise<object> {
    const url = getServiceURL(OccupancyRateAPI.getMarketOccupancyServiceName);
    const response = await requestHandler(url, { param });
    return response?.data;
  }

  static async getYearlyOccupancyRate(param: {
    owners: string[];
    properties: string[];
    beds: string[];
    year: number[];
  }): Promise<object> {
    const url = getServiceURL(
      OccupancyRateAPI.getYearlyOccupancyRateServiceName
    );
    const response = await requestHandler(url, {
      ...param,
      properties: param?.properties.map((el) => el.split("-")[0]),
    });
    return response?.data?.data;
  }

  static async getYearlyMarketOccupancyRate({
    year = "2022",
  }: IOccupancyAPI): Promise<object> {
    const url = getServiceURL(
      OccupancyRateAPI.getYearlyMarketOccupancyServiceName
    );
    const response = await requestHandler(url, { year });
    return response?.data?.MarketOccupancyRate;
  }

  static async getPaidReservationsRate({
    param,
  }: IOccupancyAPI): Promise<object> {
    const url = getServiceURL(
      OccupancyRateAPI.getPaidReservationsOccupancyServiceName
    );
    const response = await requestHandler(url, { param });
    return response?.data?.PaidReservationOccupancy;
  }

  static async getOwnerBlocksRate(param: {
    owners: string[];
    properties: string[];
    beds: string[];
  }): Promise<IOccupancyRates> {
    const url = getServiceURL(
      OccupancyRateAPI.getOwnerBlocksOccupancyServiceName
    );
    const response = await requestHandler(url, {
      ...param,
      properties: param?.properties.map((el) => el.split("-")[0]),
    });
    return response?.data?.data;
  }

  static async getDailyOccupancyRate({
    param,
  }: IOccupancyAPI): Promise<object> {
    const url = getServiceURL(OccupancyRateAPI.getDailyOccupancyServiceName);
    const response = await requestHandler(url, { param });
    return response?.data?.DailyOccupancyRate;
  }
}
